import { render, staticRenderFns } from "./JobTeaser.vue?vue&type=template&id=73b47840&"
import script from "./JobTeaser.vue?vue&type=script&lang=js&"
export * from "./JobTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports